import { getAxiosBackendApi1 } from "../helpers/axios"

class ActivitiesServices{

    constructor(){
    }

    addActivities(data){
        return getAxiosBackendApi1().post('activities', data)
    }
}

export default new ActivitiesServices()